import React from 'react';
import { AiSkeleton } from './styled';

const Skeletons = (props) => {
  const { ...rest } = props;
  return <AiSkeleton {...rest} data-testid="skeletons" />;
};
export default Skeletons;
